<template>
	<div class="im-body-container-tool">
		<span class="tool-btn help-btn">
			<a class="icon icon-bangzhu" href="javascript:;" title="帮助"></a>
			<div class="list">
				<a href="http://t.itaojin.cn/customer/action/workbench/index?imTpl=oldTpl" target="_blank">返回老版IM</a>
				<a v-if="$store.state.userInfo.id" class="js-show-customer-rank-btn" :href="rankLink" target="_blank">排行榜</a>
				<a class="js-set-im-btn" href="javascript:;" @click="showSetImBox">设置</a>
				<a href="javascript:;" @click="feedback">问题反馈</a>
			</div>
		</span>

		<div class="replace-skin tool-btn">
			<a class="icon icon-pifu" href="javascript:;" title="换肤"></a>
			<ul>
				<li :class="{blue: true, active: (setImObj.pifu == 'im-pifu-blue' || setImObj.pifu == '')}" @click="changePiFu('im-pifu-blue')"></li>
				<li :class="{green: true, active: setImObj.pifu == 'im-pifu-green'}" @click="changePiFu('im-pifu-green')"></li>
				<li :class="{red: true, active: setImObj.pifu == 'im-pifu-red'}" @click="changePiFu('im-pifu-red')"></li>
				<li :class="{black: true, active: setImObj.pifu == 'im-pifu-black'}" @click="changePiFu('im-pifu-black')"></li>
			</ul>
		</div>

		<a class="icon icon-zuidahua tool-btn" href="javascript:;" :title="setImObj.zuidahua ? '最小化' : '最大化'" @click="changeZuiDaHua"></a>

		<form v-show="$store.state.showSetImForm" class="im-set-im-form" action="javascript:;">
			<dl>
				<dt>快捷回复列表</dt>
				<dd>
					<el-checkbox v-model="allQrStretch">自动展开</el-checkbox>
				</dd>
			</dl>
			<dl>
				<dt>新消息通知</dt>
				<dd>
					<el-checkbox v-model="msgMute">静音</el-checkbox>
					<el-checkbox v-model="disabledMsgWarn">禁用右下角提示</el-checkbox>
				</dd>
			</dl>
			<dl>
				<dt>聊天框字号调整</dt>
				<dd>
					<div class="set-font-size-box">
						<div class="minus btn" @click="minusFontSize"></div>
						<input type="text" v-model="fontSize" @blur="fontSizeBlur">
						<div class="plus btn" @click="plusFontSize"></div>
					</div>
				</dd>
				<dd class="btn-box clear">
					<a class="button gray pull-left" href="javascript:;" @click="$store.commit('changeShowSetImForm', false)">取消</a>
					<a class="button pull-right" href="javascript:;" @click="saveSetImForm">保存</a>
				</dd>
			</dl>
		</form>
	</div>
</template>

<script>
import Logan from 'logan-web';
export default {
	name: 'setIm',
	data () {
		return {
			setImKey: 'SETIM',
			allQrStretch: false,
			msgMute: false,
			disabledMsgWarn: false,
			fontSize: 12,
			rankLink: ''
		}
	},
	computed: {
		setImObj () {
			return this.$store.state.setImObj;
		},
		userInfo () {
			return this.$store.state.userInfo;
		}
	},
	watch: {
		userInfo: {
			deep: true,
			handler (now) {
				this.rankLink = API_ROOT.cUrl + '/wwim/customerClusterRankInfo/index?tjkId=' + now.id;
			}
		}
	},
	mounted: function () {
		this.initSetIm();
	},
	methods: {
		// 初始化IM设置
		initSetIm () {
			var self = this,
				setJson = localStorage.getItem(self.setImKey) ? JSON.parse(localStorage.getItem(self.setImKey)) : {};

			self.setImObj.pifu = setJson['pifu'] ? setJson['pifu'] : '';
			self.setImObj.zuidahua = !!setJson['zuidahua'];
			self.setImObj.msgMute = !!setJson['msgMute'];
			self.setImObj.allQrStretch = !!setJson['allQrStretch'];
			self.setImObj.disabledMsgWarn = !!setJson['disabledMsgWarn'];
			self.setImObj.fontSize = setJson['fontSize'] || 12;

			self.$store.commit('changeSetImObj', self.setImObj);
		},

		// 显示设置框
		showSetImBox () {
			var self = this;

			self.initSetImForm();
			self.$store.commit('changeShowSetImForm', true);
		},

		// 初始化设置框参数
		initSetImForm () {
			var self = this;

			self.allQrStretch = self.setImObj.allQrStretch;
			self.msgMute = self.setImObj.msgMute;
			self.disabledMsgWarn = self.setImObj.disabledMsgWarn;
			self.fontSize = self.setImObj.fontSize;
		},

		// 换肤
		changePiFu (pifuName) {
			var self = this,
				setJson = localStorage.getItem(self.setImKey) ? JSON.parse(localStorage.getItem(self.setImKey)) : {};

			setJson['pifu'] = pifuName;
			localStorage.setItem(self.setImKey, JSON.stringify(setJson));
			self.$store.commit('changeSetImObj', setJson);
		},

		// 最大化/最小化
		changeZuiDaHua () {
			var self = this,
				setJson = localStorage.getItem(self.setImKey) ? JSON.parse(localStorage.getItem(self.setImKey)) : {},
				zuidahua = !setJson['zuidahua'];

			setJson['zuidahua'] = zuidahua;
			localStorage.setItem(self.setImKey, JSON.stringify(setJson));
			self.$store.commit('changeSetImObj', setJson);
		},

		// 减小字体大小
		minusFontSize () {
			var self = this;
			if (self.fontSize > 12) self.fontSize--;
		},

		// 增加字体大小
		plusFontSize () {
			var self = this;
			if (self.fontSize < 24) self.fontSize++;
		},

		// 设置字体大小输入框失去焦点
		fontSizeBlur () {
			var self = this;
			if (isNaN(self.fontSize)) {
				self.fontSize = 12;
			} else if (self.fontSize < 12) {
				self.fontSize = 12;
			} else if (self.fontSize > 24) {
				self.fontSize = 24;
			}
		},

		// 保存设置
		saveSetImForm () {
			var self = this,
				setJson = localStorage.getItem(self.setImKey) ? JSON.parse(localStorage.getItem(self.setImKey)) : {};

			setJson['allQrStretch'] = self.allQrStretch;
			setJson['msgMute'] = self.msgMute;
			setJson['disabledMsgWarn'] = self.disabledMsgWarn;
			setJson['fontSize'] = parseInt(self.fontSize);

			localStorage.setItem(self.setImKey, JSON.stringify(setJson));
			self.$store.commit('changeSetImObj', setJson);
			self.$store.commit('changeShowSetImForm', false);
		},

		// 问题反馈
		async feedback () {
			if (this.feedbackLoading) return
			this.feedbackLoading = true

			let now = +new Date();
			const reportResult = await Logan.report({
				reportUrl: API_ROOT.logUrl + '/logan/web/upload.json',
				deviceId: this.userInfo.id,
				fromDayString: (new Date(now - 3*24*60*60*1000).format('yyyy-MM-dd')),
				toDayString: (new Date(now).format('yyyy-MM-dd'))
			});
			let checked = true
			for(let k in reportResult) {
				if (!(reportResult[k].msg == 'No log exists' || reportResult[k].msg == 'Report succ')) {
					checked = false
					break;
				}
			}
			if (checked) {
				this.$message.success('日志提交成功，请耐心等待开发人员的回复！')
			} else {
				this.$message.error('日志提交失败！')
			}

			this.feedbackLoading = false
		}

	}
}
</script>



// WEBPACK FOOTER //
// src/pages/head/setIm.vue